<div class="auth-wrapper d-flex no-block justify-content-center align-items-center"
     [style]="'background-image:url('+ environment.loginbgPath +')'"
>
  <div class="auth-box m-3 m-md-0">
    <div>
      <div class="logo">
        <span class="db"><img [src]="environment.logoPath" style="width: -webkit-fill-available" alt="logo" /></span>
        <br>
        <br>
        <h5 class="font-medium m-b-20">{{'cliente.registrati' | translate}}</h5>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="form-horizontal m-t-20" action="index.html">
            <div class="form-group row" *ngIf="UserTypes?.length>0 && !environment.Wp">
              <div class="col-12" >
                <label for="tipo" class="mb-0 text-white">Tipologia</label>
                <ng-multiselect-dropdown [settings]="dropdownSettings" style="width: 80%; " [placeholder]="'Tipo'" id="tipo" name="Tipologia" [data]="UserTypes"
                                         [(ngModel)]="SelectedUserTypes" (ngModelChange)="OnTypeChange()">
                </ng-multiselect-dropdown>
              </div>
            </div>
            <div class="form-group row" *ngIf="NominativoRequired && !environment.Wp">
              <div class="col-12 ">
                <label class="mb-0 text-white">{{'cliente.nominativo' | translate}}</label>
                <input class="form-control" type="text" [(ngModel)]="User.nominativo" required=" "  placeholder="{{'cliente.nominativo' | translate}}">
              </div>
            </div>
            <div class="form-group row" *ngIf="!environment.Wp">
              <div class="col-12 ">
                <label class="mb-0 text-white">{{'cliente.piva' | translate}}</label>
                <input class="form-control" type="text" [(ngModel)]="User.piva" required=" "  placeholder="{{'cliente.piva' | translate}}">
              </div>
            </div>
            <div class="form-group row " >
              <div class="col-12 ">
                <label class="mb-0 text-white">{{'cliente.nome' | translate}}</label>
                <input class="form-control" type="text" [(ngModel)]="User.nome" required=" "  placeholder="{{'cliente.nome' | translate}}">
              </div>
            </div>
            <div class="form-group row ">
              <div class="col-12 ">
                <label class="mb-0 text-white">{{'cliente.cognome' | translate}}</label>
                <input class="form-control" type="text" [(ngModel)]="User.cognome" required=" "  placeholder="{{'cliente.cognome' | translate}}">
              </div>
            </div>
            <div class="form-group row">
              <div class="col-12 ">
                <label class="mb-0 text-white">{{'cliente.email' | translate}}</label>
                <input class="form-control" type="text" [(ngModel)]="User.email" required=" " placeholder="{{'cliente.email' | translate}}">
              </div>
            </div>
            <div class="form-group row" *ngIf="false">
              <div class="col-12 ">
                <label class="mb-0 text-white">{{'cliente.username' | translate}}</label>
                <input class="form-control" type="text" [(ngModel)]="User.username" required=" " placeholder="{{'cliente.username' | translate}}">
              </div>
            </div>
            <div class="form-group row">
              <div class="col-12 ">
                <label class="mb-0 text-white">{{'cliente.password' | translate}}</label>
                <div class="input-group">
                  <input  [ngClass]="{'is-invalid': User?.password?.length < 8, 'form-control':true}" [type]="mostrapassword ? 'text' : 'password'" [(ngModel)]="User.password" required=" " placeholder="{{'cliente.password' | translate}}">
                  <div class="input-group-append">
                    <button class="btn mr-0 btn-outline-white" type="button" (click)="mostrapw()"><i class="fas " [ngClass]="{'fa-eye': !mostrapassword, 'fa-eye-slash': mostrapassword}"></i></button>
                  </div>
                </div>
                <small class="form-text text-danger" *ngIf="User?.password?.length<8">{{'cliente.pwminlen' | translate}}</small>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-12 ">
                <label class="mb-0 text-white">{{'cliente.cpassword' | translate}}</label>
                <input [ngClass]="{'is-invalid': User?.password != User?.password_confirmation, 'form-control':true}" type="password" [(ngModel)]="User.password_confirmation" placeholder="{{'cliente.cpassword' | translate}}">
                <small class="form-text text-danger" *ngIf="User?.password != User?.password_confirmation ">{{'cliente.pwsame' | translate}}</small>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-12 ">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="customCheck1" [(ngModel)]="User.privacy">
                  <label class="custom-control-label" for="customCheck1">Accetto tutti i <a href="javascript:void(0)" (click)="openTerms()">Termini e Condizioni</a></label>
                </div>
              </div>
            </div>
            <div class="form-group text-center ">
              <div class="col-xs-12 p-b-20 ">
                <a class="btn btn-block btn-lg btn-info" (click)="SignUp()">{{'cliente.registrati' | translate}}</a>
              </div>
            </div>
            <div class="form-group m-b-0 m-t-10 ">
              <div class="col-sm-12 text-center ">
                Hai gia un account? <a href="/Login" class="text-info m-l-5 "><b>{{'cliente.accedi' | translate}}</b></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
